import { useState } from "react";
import { ChevronDown } from "lucide-react";

interface FAQItem {
  question: string;
  answer: string;
}

interface FAQSectionProps {
  faqs: FAQItem[];
  title?: string;
  showButtons?: boolean;
  imageSrc?: string;
}

export default function FAQSection({
  faqs,
  title = "Frequently asked questions",
}: FAQSectionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (idx: number) => {
    setOpenIndex(openIndex === idx ? null : idx);
  };

  return (
    <section className="py-12 md:py-20 px-4 sm:px-6 lg:px-8">
      <div className="container">
        <div className="max-w-3xl mx-auto">
          {/* Centered FAQ section */}
          <h2 className="text-3xl md:text-4xl font-bold mb-12 text-center">
            {title}
          </h2>

          <div className="space-y-1">
            {faqs.map((faq, idx) => (
              <div key={idx} className="border-b border-gray-700/50">
                <button
                  onClick={() => toggleFAQ(idx)}
                  className="w-full flex items-center justify-between py-5 hover:text-blue-400 transition"
                >
                  <span className="font-medium text-left text-base md:text-lg">
                    {faq.question}
                  </span>
                  <ChevronDown
                    size={20}
                    className={`transition-transform flex-shrink-0 ml-4 ${openIndex === idx ? "rotate-180" : ""
                      }`}
                  />
                </button>

                {openIndex === idx && (
                  <div
                    className="pb-5 leading-relaxed"
                    dangerouslySetInnerHTML={{ __html: faq.answer }}
                  />
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

// Export the FAQItem type for use in other files
export type { FAQItem };